import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import React, { useCallback, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';

import { BsPersonFill } from 'react-icons/bs';

import axios, { AxiosError } from 'axios';
import { useToast } from '../../hooks/toast';
import getValidationErrors from '../../utils/getValidationsErrors';

import Button from '../../components/Button';
import Input from '../../components/Input';

import logo from '../../assets/logo.png';

import { Background, Content } from './styles';

interface ForgotPasswordFormData {
  email: string;
}

const ForgotPassword: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);

  const submitHandler = useCallback(
    async (data: ForgotPasswordFormData) => {
      setLoading(true);
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string().required('E-mail obrigatório').email('Digite um e-mail válido'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const apiUrl = process.env.REACT_APP_API_URL;
        await axios.post(`${apiUrl}/password/forgot`, { email: data.email });

        addToast({
          type: 'success',
          title: 'E-mail enviado',
          description: 'Enviamos um e-mail para confirmar a recuperação de senha, cheque sua caixa de entrada',
        });

        formRef.current?.reset();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          return formRef.current?.setErrors(errors);
        }

        return addToast({
          type: 'error',
          title: 'Erro ao recuperar senha',
          description: (error as AxiosError).response ? `${(error as AxiosError).response?.data.message}` : `${error}`,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast],
  );

  return (
    <Background>
      <Content>
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>
        <Form ref={formRef} onSubmit={submitHandler}>
          <h2>Recuperar Senha</h2>
          <p>Digite seu e-mail para receber as instruções de recuperação</p>
          <Input icon={BsPersonFill} color="#0C5C75" size={20} name="email" type="text" placeholder="Email" />

          <Button name="recover" isLoading={loading}>
            {loading ? 'Enviando...' : 'Enviar'}
          </Button>

          <Link to="/">Voltar para login</Link>
        </Form>
      </Content>
    </Background>
  );
};
export default ForgotPassword;
